import React, { useState } from 'react';
import './FAQ.scss';

const FAQComponent = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "How much will it cost to sell my property?",
      answer: `When selling a property, three primary costs are involved:\n\n
      <strong>Estate Agent Fees</strong>\n
      Estate agent fees can be either a percentage of the sale price or a fixed amount. Ensure agents provide a clear outline of their fees when valuing your home.\n\n
      <strong>Energy Performance Certificate (EPC)</strong>\n
      An EPC, detailing your property's energy efficiency, is legally required for marketing. Your Move can arrange this—contact your local branch for a quote. In Scotland, a Home Report, which includes an EPC, is needed.\n\n
      <strong>Conveyancing</strong>\n
      Conveyancing involves the legal transfer of property to the buyer, requiring a solicitor. Costs vary, but Your Move offers a no sale, no fee conveyancing service with a fixed price.\n\n
      Additional costs may include professional photography, advanced web positioning, and removals. Ensure your agent outlines all potential expenses upfront to help you budget effectively.`
    },
    {
      question: "I want to sell a property. What do I do first?",
      answer: `The first step in selling your property is to get a home valuation.\n\nThis will give you an idea of how much your property is worth in the current market. We offer a free home valuation service, where an experienced estate agent will visit your property, assess its condition, location, and features, and provide you with an estimated sale price. This initial valuation is crucial as it sets the foundation for your pricing strategy and helps you understand the potential value of your home.\n\nContact us today to schedule your free home valuation and take the first step towards selling your property.`
    },
    {
      question: "Do I need to conduct viewings?",
      answer: "Your estate agent should accompany all viewings, but you may decide that you’d like to be present. It’s really up to you."
    },
    {
      question: "Will there be more viewings once I've accepted an offer?",
      answer: `This partly depends on the conditions of the offer. Remember, neither the buyer or the seller is bound to the purchase or sale until the contracts are signed and exchanged, so it’s worth keeping your options open.`
    },
    {
      question: "How long will it take to complete my sale?",
      answer: `Every sale is different. Both your position and the buyer’s position needs to be taken into account before this question can be answered accurately. If your home has been realistically valued, you should expect to receive offers within the first four weeks. Then, assuming your buyer has to apply for their mortgage, the exchange of contracts normally takes between 4 and 6 weeks and then completion is between 2 and 4 weeks later.\n\nSo in total you should expect 12-14 weeks to complete the sale.`
    },
    {
      question: "Do I need an EPC?",
      answer: "In England, all sellers are required to purchase an EPC for a property before they sell it. Estate agents must display the EPC rating whenever they market the property. If you’ve had one done recently, it may still be valid.  Your Estate Agent can check for you."
    },
    {
      question: "I want to let my property. Do I need to tell my mortgage lender?",
      answer: "Yes. Your mortgage lender needs to give you permission before you can let your property, and they may impose special conditions. If you are buying a property with the intention of letting it out, you may be able to obtain a buy to let mortgage."
    },
    {
      question: "How do I know what rent to charge?",
      answer: "Ask a letting agent to value your home. At Your Move, we’re experts in the market, so we can tell you how other rental properties are doing in the area, and what kind of yield you can hope to expect. Book a rental valuation with Your Move - Chris Stonock."
    },
    {
      question: "How much will it cost me to let my property?",
      answer: "This really depends on how much support you need. At Your Move we offer three main service levels: Tenant Find, Rent Collect and Fully Managed.\n\nEach involves a different degree of service from Your Move - Chris Stonock and the fees we charge reflect this. Be sure you understand an agent’s fees and exactly what you receive for your money when you ask them to conduct a lettings valuation."
    },
    {
      question: "Does a landlord need to pay tax on rental income?",
      answer: "All landlords could be liable to pay tax on their rental income, whether they live in the UK or are based overseas. Further information can be found on the Inland Revenue’s website."
    }
  ];

  return (
    <div className="faq-container">
      <h1 className="faq-headline">FAQs</h1>
      {faqs.map((faq, index) => (
        <div key={index} className={`faq-item ${index === faqs.length - 1 ? 'last' : ''}`}>
          <div className="faq-question" onClick={() => toggleFAQ(index)}>
            {faq.question}
            <span className={`faq-toggle ${openIndex === index ? 'open' : ''}`}>
              {openIndex === index ? '-' : '+'}
            </span>
          </div>
          <div
            className={`faq-answer ${openIndex === index ? 'open' : ''}`}
            dangerouslySetInnerHTML={{ __html: faq.answer }}
          />
        </div>
      ))}
    </div>
  );
};

export default FAQComponent;
